import { DeviceMediafileObjectType, usePointGenerationSettingsLazyQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { useMemo } from 'react';

const usePointGenerationSettings = () => {
  const [query, queryResult] = usePointGenerationSettingsLazyQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const request = async (pointId: string) => {
    await query({
      variables: {
        pointId,
      },
      fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    });
  };

  const mediafiles = useMemo(
    () =>
      queryResult.data?.pointGenerationSettingsPureQuery.mediafiles.reduce(
        (acc, mf) => {
          if (!mf || !mf.id) return acc;
          acc[mf.id] = mf;
          return acc;
        },
        {} as { [id: number]: DeviceMediafileObjectType }
      ),
    [queryResult.data?.pointGenerationSettingsPureQuery.mediafiles]
  );

  return {
    request,
    error: queryResult.error,
    isLoading: queryResult.loading,
    settings: queryResult.data?.pointGenerationSettingsPureQuery.settings,
    mediafiles,
  };
};

export default usePointGenerationSettings;
